module.exports = __webpack_public_path__ + "static/media/music-fill.c864d703.svg";